import React from 'react';
import { DayPicker, DayPickerSingleProps } from 'react-day-picker';
import * as styles from './Calendar.module.scss';

interface CalendarProps extends Omit<DayPickerSingleProps, 'mode'> {}

export function Calendar({ ...restProps }: CalendarProps) {
  return (
    <DayPicker
      mode="single"
      classNames={{
        root: styles.calendar,
        caption: styles.calendarTopContainer,
        day: styles.calendarDay,
        day_selected: styles.calendarDaySelected,
        day_disabled: styles.calendarDayDisabled,
        caption_label: styles.calendarMonth,
        head_cell: styles.calendarMonths,
        nav: styles.calendarArrowContainer,
        nav_button_previous: styles.calendarArrow,
        nav_button_next: styles.calendarArrow,
        nav_icon: styles.calendarArrowIcon,
      }}
      {...restProps}
    />
  );
}
